<p-button
  [styleClass]="styleClass()"
  [dt]="dt()"
  [size]="size()"
  [loading]="loading()"
  [severity]="severity()"
  [text]="text()"
  [disabled]="disabled()"
  (onClick)="onClick()">
    <span [ngClass]="{
      'invisible': (size() === 'small' && loading()) && false,
      'underline': text()
    }">{{ submitButtonLabel() }}</span>
</p-button>
